
<script setup lang="ts">
import Modal from "@/Components/Modal.vue";
import { tgUrl } from "@/constants.js";

defineProps<{
    isOpen: boolean;
}>();
defineEmits<{
    (e: 'onToggle', payload: boolean): void
}>()
</script>

<template>
    <Modal :show="isOpen" max-width="2xl" modalClass="h-[90dvh]">
        <div class="py-5 px-3 flex flex-col bg-slate-200 z-20 h-full">
            <div class="w-full flex justify-end pb-6 border-dashed border-black border-b">
                <button @click="$emit('onToggle', true)" class="bg-transparent border-none outline-hidden">
                    <img src="/assets/img/roblox/close-modal.svg" alt="close-modal">
                </button>
            </div>
            <div class="px-3 py-5 flex flex-col items-center font-medium rounded-lg">
                <p class="text-black font-['Unbounded'] text-lg">
                    {{$t('How to get a promo code?')}}
                </p>
                <div class="relative z-20 sm:z-0 mt-[22px] w-[146px]">
                    <img alt="prizebox"
                         src="/assets/img/roblox/tg-draw-logo.webp" style="width: 101px; height: 106px">
                </div>
                <p class="flex items-center gap-3 font-sans text-base mt-[22px]">
                    <span class="text-center" v-html="$t(`Visit our Telegram channel.<br>Always the latest promo codes!`)"></span>
                </p>
                <a :href="tgUrl" target="_blank" class="flex mt-6 items-center gap-2.5 bg-cyan-500 shadow-[inset_1px_-3px_2px_rgba(0,0,0,0.3)] w-full justify-center py-4 rounded-full font-sans font-medium text-white transition-opacity hover:opacity-60">
                    <span class="text-[18px]" v-html="$t('Get a promotional code')"></span>
                    <img src="/assets/img/roblox/link-icon.svg" alt="link=icon" style="width: 30px; height: 30px;">
                </a>
            </div>
        </div>
    </Modal>
</template>
